import moment from 'moment';

import APIClient from '../../../../common/services/APIClient';
import { setMessageExportUnavailable } from '../../../../common/components/Alert/actions';
import { fileDownload } from '../../../../common/services/fileUtils';

const MODULE_PREFIX = 'SSO_ACCOUNTS_';

export const SET_ACCOUNTS_TYPE = `${MODULE_PREFIX}SET_ACCOUNTS`;
export const SET_MANAGED_ACCOUNT_EMAIL_TYPE = `${MODULE_PREFIX}SET_MANAGED_ACCOUNT_EMAIL`;
export const SET_MANAGED_CUSTOMER_ID_TYPE = `${MODULE_PREFIX}SET_MANAGED_CUSTOMER_ID`;
export const SET_CUSTOMERS_TYPE = `${MODULE_PREFIX}SET_CUSTOMERS`;
export const TOGGLE_SELECT_ALL_ACCOUNTS = `${MODULE_PREFIX}TOGGLE_SELECT_ALL_ACCOUNTS`;
export const DESELECT_ALL_ACCOUNTS = `${MODULE_PREFIX}DESELECT_ALL_ACCOUNTS`;
export const TOGGLE_CHECKED_ACCOUNTS = `${MODULE_PREFIX}TOGGLE_CHECKED_ACCOUNTS`;

export const setAccounts = (accounts) => ({
  type: SET_ACCOUNTS_TYPE,
  payload: accounts,
});

export const setManagedAccountEmail = (email) => ({
  type: SET_MANAGED_ACCOUNT_EMAIL_TYPE,
  payload: email,
});

export const setManagedCustomerId = (id) => ({
  type: SET_MANAGED_CUSTOMER_ID_TYPE,
  payload: id,
});

export const setCustomers = (customers) => ({
  type: SET_CUSTOMERS_TYPE,
  payload: customers,
});

export const toggleSelectAll = () => ({
  type: TOGGLE_SELECT_ALL_ACCOUNTS,
});

export const deselectAll = () => ({
  type: DESELECT_ALL_ACCOUNTS,
});

export const toggleChecked = (account) => ({
  type: TOGGLE_CHECKED_ACCOUNTS,
  account,
});

export const exportAccounts = (emails = [], customerId = '', customerName = '') => (dispatch) => {
  if (!customerId) {
    throw new Error('CustomerId is required for export!');
  }
  if (!customerName) {
    throw new Error('Customer name is required for export!');
  }

  const payload = {
    emails,
    customerId,
  };

  return APIClient.post('userRoles/sso/export', payload)
    .then(({ data, headers }) => {
      const formattedCustomerName = customerName.trim().replaceAll(' ', '_');
      const exportDate = moment().format('YYYY-MM-DD_hh-mm-ss');
      const ext = '.csv';
      const fileName = `SSO_Accounts_${formattedCustomerName}_${exportDate}${ext}`;

      fileDownload(data, fileName, headers['content-type']);
    })
    .catch((err) => {
      if (err.response && err.response.status === 500) {
        dispatch(setMessageExportUnavailable());
      }
      console.error(err);
    });
};
